module.exports = {
  selectLanguage: "日本語",
};
